class ProductsServiceClass {
  constructor() {
    this.count = 0;
    this.filterArgs = {};
    this.abortController = null;
    this.actionParam = "acfbk_wc_action";
    this.filterArgsParam = "acfbk_wc_filter_args";
    this.actionValue = "products-count-filtered";
  }

  setEndpointConfig(config = {}) {
    if (typeof config.actionParam === "string" && config.actionParam !== "") {
      this.actionParam = config.actionParam;
    }

    if (typeof config.filterArgsParam === "string" && config.filterArgsParam !== "") {
      this.filterArgsParam = config.filterArgsParam;
    }

    if (typeof config.actionValue === "string" && config.actionValue !== "") {
      this.actionValue = config.actionValue;
    }
  }

  abortProductsCount() {
    if (this.abortController) {
      this.abortController.abort();
    }
  }

  setFilterArgs(args) {
    this.filterArgs = args;
  }

  async countFilteredProducts() {
    if (this.abortController) {
      this.abortController.abort();
    }

    this.abortController = new AbortController();
    const signal = this.abortController.signal;

    const filterArgs = encodeURIComponent(JSON.stringify(this.filterArgs));
    const url = new URL(window.location.href);
    url.searchParams.set(this.actionParam, this.actionValue);
    url.searchParams.set(this.filterArgsParam, filterArgs);

    try {
      const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        signal,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      this.count = Number(data?.data?.count ?? 0);
      return this.count;
    } catch (error) {
      if (error?.name !== "AbortError") {
        console.error("Filtered products request failed", error);
      }
      this.count = -1;
      return this.count;
    } finally {
      this.abortController = null;
    }
  }
}

const ProductsService = new ProductsServiceClass();
export default ProductsService;
